// @flow
export const SET_COOKIES_HEIGHT = "SET_COOKIES_HEIGHT"

export type SetCookiesHeightAction = { type: "SET_COOKIES_HEIGHT", height: number }

// eslint-disable-next-line import/prefer-default-export
export function setCookiesHeight(height: number) {
  return {
    type: SET_COOKIES_HEIGHT,
    height,
  }
}
